import React, { FC } from 'react';
import { Customer, Operation, Product, MinimalUser, OperationContentWrapper } from '../..';
import { OperationContent } from './OperationContent';

export interface AdditionalOperationListContentProps {
  operation: Operation;
  users: MinimalUser[];
  customers: Customer[];
  products: Product[];
  isPreview?: boolean;
}

export const AdditionalOperationListContent: FC<AdditionalOperationListContentProps> = (props) => {
  const { operation, users, customers, products, isPreview = true } = props;
  return (
    <OperationContentWrapper isPreview={isPreview}>
      <OperationContent operation={operation} users={users} customers={customers} products={products} isPreview={isPreview} />
    </OperationContentWrapper>
  );
};
